import type { SVGProps } from "react";
import { memo } from "react";
const ReservedInstanceReporting = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#1B660F" />
        <stop offset="100%" stopColor="#6CAE3E" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m56.344 54.964-8.536-8.537-1.414 1.414 8.519 8.52-14.907 6.179-14.985-6.202 8.541-8.541-1.414-1.415-8.515 8.516-6.174-14.893 6.177-14.922 8.522 8.523 1.415-1.414-8.534-8.534 14.955-6.199 14.907 6.17-8.518 8.518 1.414 1.414 8.538-8.538 6.206 14.971zM68 41v-2h-3.707l-6.427-15.509 3.135-3.135-1.414-1.414-3.155 3.156L41 15.711V12h-2v3.706l-15.492 6.422-3.185-3.186-1.414 1.414 3.197 3.196L15.711 39H12v2h3.707l6.395 15.429-3.193 3.192 1.414 1.414 3.167-3.166L39 64.289V68h2v-3.707l15.445-6.401 3.142 3.143 1.414-1.414-3.126-3.126L64.289 41zm-28 4.72A5.726 5.726 0 0 1 34.281 40 5.726 5.726 0 0 1 40 34.279 5.726 5.726 0 0 1 45.72 40 5.726 5.726 0 0 1 40 45.72m0-13.441c-4.257 0-7.719 3.464-7.719 7.721s3.462 7.72 7.719 7.72 7.72-3.464 7.72-7.72-3.463-7.721-7.72-7.721"
      />
    </g>
  </svg>
);
const Memo = memo(ReservedInstanceReporting);
export default Memo;
